/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserNotifications = {
    properties: {
        active: {
            type: 'boolean',
            isRequired: true,
        },
        hints: {
            type: 'boolean',
            isRequired: true,
        },
        teamOfTheWeek: {
            type: 'boolean',
            isRequired: true,
        },
        manOfTheMatch: {
            type: 'boolean',
            isRequired: true,
        },
        ratingUpdate: {
            type: 'boolean',
            isRequired: true,
        },
        socials: {
            type: 'boolean',
            isRequired: true,
        },
        insiderMatch: {
            type: 'boolean',
            isRequired: true,
        },
        toto: {
            type: 'boolean',
            isRequired: true,
        },
    },
} as const;
